import React from "react";
import {Tag} from 'antd';
import RenderIf from "@/components/render-if";

function MemberTypeComponent({member}) {
    return (
        <>
            <RenderIf condition={member?.student}>
                <Tag color="blue">
                    دانش آموز
                </Tag>
            </RenderIf>
            <RenderIf condition={member?.teacher}>
                <Tag color="orange">
                    مربی
                </Tag>
            </RenderIf>
            <RenderIf condition={member?.expert}>
                <Tag color="red">
                    کارشناس
                </Tag>
            </RenderIf>

        </>
    )
}

export default MemberTypeComponent